
import { supabase } from "@/integrations/supabase/client";

export const performAISearch = async (query: string) => {
  try {
    console.log('Starting AI search for:', query);
    
    const response = await supabase.functions.invoke('ai-vacation-search', {
      body: { query }
    });

    console.log('AI Search response:', response);

    if (response.error) {
      console.error('AI search error:', response.error);
      throw new Error('AI search failed');
    }

    const { vacations } = response.data || {};
    
    if (!vacations || vacations.length === 0) {
      console.log('No AI results found');
      return [];
    }

    console.log(`Found ${vacations.length} vacations with AI search`);
    
    // Ensure each vacation has the required fields
    const validatedVacations = vacations.map((vacation: any) => ({
      ...vacation,
      name: vacation.name || vacation.title || "Onbekende vakantie",
      imageURL: vacation.imageURL || vacation.image || "/placeholder.svg"
    }));
    
    return validatedVacations;
  } catch (error: any) {
    console.error('AI search error:', error);
    throw error;
  }
};
